import React from 'react';
import dayjs from 'dayjs'

export default class Card extends React.Component {
    goTo() {
        const { cheer, history } = this.props;
        window.scrollTo(0, 0);
        history.push(`/cheers/${cheer._id}`);
    }

    _getPostLike(likes) {
        const { account } = this.props;
        const like = likes.find(like => like.user === account._id);
        return like._id;
    }

    handleRemoveEntry(cheerId) {
        const shouldRemove = confirm("Are you sure you want to remove this cheer?");
        if (shouldRemove) {
            this.props.deleteCheer(cheerId);
        }
    }

    render() {
        const { cheer, iLike, account } = this.props;
        const showRemove = account.admin || (Boolean(cheer) && Boolean(cheer.createdBy) && account._id === cheer.createdBy._id);
        const iLikeVal = iLike();
        const postLike = iLikeVal && this._getPostLike(cheer.likes);
        const hasName = Boolean(cheer.createdBy);
        return (
            <div className="p-4 md:w-1/2 w-full">
                <div className="h-full bg-gray-300 p-8 rounded">
                    <svg xmlns="http:www.w3.org/2000/svg" fill="currentColor" className="block w-5 h-5 text-gray-400 mb-4" viewBox="0 0 975.036 975.036">
                        <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
                    </svg>
                    <p className="leading-relaxed mb-6">{cheer.description}</p>
                    <a className="inline-flex items-center">
                        {iLikeVal ?
                            <svg
                            onClick={() => this.props.removePostLike(cheer._id, postLike)}
                            className="relative cursor-pointer h-6 w-6 text-red-600 fill-current" xmlns="http:www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                            :
                            <svg onClick={() => this.props.likePost(cheer._id)} className="relative cursor-pointer h-6 w-6 text-gray-900 fill-current" xmlns="http:www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12.76 3.76a6 6 0 0 1 8.48 8.48l-8.53 8.54a1 1 0 0 1-1.42 0l-8.53-8.54a6 6 0 0 1 8.48-8.48l.76.75.76-.75zm7.07 7.07a4 4 0 1 0-5.66-5.66l-1.46 1.47a1 1 0 0 1-1.42 0L9.83 5.17a4 4 0 1 0-5.66 5.66L12 18.66l7.83-7.83z"></path>
                            </svg>
                        }
                        <span className="flex-grow flex flex-col ml-4">
                        <span className="title-font font-medium text-gray-900">Cheers to {cheer.name}</span>
                        <span className="text-gray-700">{cheer.likes.length} like{cheer.likes.length === 1 ? '' : 's'}</span>
                        {hasName &&
                            <span className="text-gray-600 text-sm">Nominated by: {cheer.createdBy.firstName} {cheer.createdBy.lastName} on {dayjs(cheer.createdAt).format('MMM DD, YYYY')}</span>
                        }
                        </span>
                    </a>
                    <div>
                        {showRemove &&
                            <div onClick={() => this.handleRemoveEntry(cheer._id)} className="ml-4 text-lg font-semibold text-red-700 cursor-pointer">Remove</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cheers/card.js